import { indexTypeApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const PROGRAM_INDEX_TYPE_ACTION_TYPE = createNamedActions('programIndexType', {
  GET_PROGRAM_INDEX_TYPES: 'GET_PROGRAM_INDEX_TYPES',
  CREATE_PROGRAM_INDEX_TYPE: 'CREATE_PROGRAM_INDEX_TYPE',
  EDIT_PROGRAM_INDEX_TYPE: 'EDIT_PROGRAM_INDEX_TYPE',
  DELETE_PROGRAM_INDEX_TYPE: 'DELETE_PROGRAM_INDEX_TYPE',
});

const programIndexTypesSchema = new schema.Entity('data', {}, { idAttribute: 'indexTypeId' });

export const getProgramIndexTypesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await indexTypeApi.getTypes();

  return dispatch({
    type: PROGRAM_INDEX_TYPE_ACTION_TYPE.GET_PROGRAM_INDEX_TYPES,
    payload: normalize(data, [programIndexTypesSchema]).entities.data,
  });
});

export const createProgramIndexTypeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await indexTypeApi.createType(params);

  return dispatch({
    type: PROGRAM_INDEX_TYPE_ACTION_TYPE.CREATE_PROGRAM_INDEX_TYPE,
    payload: data,
  });
});

export const editProgramIndexTypeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await indexTypeApi.editType(params);

  return dispatch({
    type: PROGRAM_INDEX_TYPE_ACTION_TYPE.EDIT_PROGRAM_INDEX_TYPE,
    payload: data,
  });
});

export const deleteProgramIndexTypeAction =
  ({ indexTypeId }) =>
  async dispatch => {
    await indexTypeApi.deleteType({ indexTypeId });

    return dispatch({
      type: PROGRAM_INDEX_TYPE_ACTION_TYPE.DELETE_PROGRAM_INDEX_TYPE,
      payload: indexTypeId,
    });
  };
